<template>
	<div class="home">
		<banner @gosearch="search" :hotList="hotList"></banner>
		<!-- <div class="home-box flex-between"> -->
		<!-- <listTitle :label="menuName + ' 权责事项'"></listTitle> -->
		<!-- <div class="content-title-box">
        <div class="content-title-left"></div>
        <div class="content-title">{{menuName}}类 权责事项</div>
        <div class="content-select">
          
        </div>
    </div>-->
		<!-- <div class="select-flex">
        <seclectInput left="-20" :selectlist="unitSelect" @getselect="getUnit" :value="unitValue"></seclectInput>
        <seclectInput left="-200" :selectlist="typeSelect" @getselect="getType" :value="typeValue"></seclectInput>
      </div>
    </div>-->
		<!-- <div class="home-box type-list-flex">
      <div
        class="type-list"
        v-for="(item, index) in typeSelect"
        :key="index"
        @click="getRolelistByAffairTypeId(item.Id)"
        :class="{typeActive: typeId == item.Id}"
      >
        <span>{{ item.Name }}</span>
        <span>{{ item.TotalCount1 + item.TotalCount2}}项</span>
      </div>
    </div>-->
		<!-- <div class="home-box borderBot">
      <div class="flex-between">
        <div class="qzTotal">共{{total}}项</div>
        <div class="qz-input select-flex">
          <div class="qz-input-box">
            <input type="text" v-model="keyword" placeholder="请输入要搜索的关键词" @keyup.enter="search()" />
          </div>
          <div class="qz-input-btn">
            <p @click="search()">查 询</p>
          </div>
        </div>
      </div>
    </div>-->
		<div class="home-box">
			<div class="home-box-header">
				<div class="home-box-header-step" :style="{ width: stepWidth + 'px' }"></div>
				<div class="home-box-header-menu" :style="{ 'margin-left': menuWidth + 'px' }" ref="headerMenu">
					<div class="header-menu-normal" :class="{ active: menuTypeShow }" @click="changeMenuShow(true)">
						<span>按部门</span>
					</div>
					<div class="header-menu-skew" :class="{ active: !menuTypeShow }" @click="changeMenuShow(false)">
						<span>按类别</span>
					</div>
				</div>
			</div>
			<div class="home-box-content">
				<div class="home-box-content-menu" v-if="menuTypeShow">
					<ul>
						<li
							v-for="(units, unitsIndex) in unitSelect"
							:key="unitsIndex"
							@click="getUnit(units)"
							:class="{ active: unitId == units.Id }"
						>
							<span>{{ units.Name }}</span>
						</li>
					</ul>
				</div>
				<div class="home-box-content-menu" v-if="!menuTypeShow">
					<ul>
						<li
							v-for="(types, typesIndex) in typeSelect"
							:key="typesIndex"
							@click="getType(types, 1)"
							:class="{ active: typeId == types.Id }"
						>
							<span>{{ types.Name }}</span>
						</li>
					</ul>
				</div>
				<div class="home-box-content-list">
					<div class="home-box-content-header">
						<span>{{ menuName }}</span>
						<span>></span>
						<span>权责事项</span>
					</div>
					<div class="home-box-content-splice">
						<img src="./../../assets/line@3x.png" />
					</div>
					<div class="home-box-content-typeList" v-if="menuTypeShow">
						<ul>
							<li :class="{ active: typeId == -1 }" @click="getType({ Name: '全部', Id: -1 })">
								<span>全部{{ typeTotal }}项</span>
							</li>
							<li
								v-for="(types, typesIndex) in typeSelect"
								:key="typesIndex"
								@click="getType(types, 2)"
								:class="{ active: typeId == types.Id }"
							>
								<span>{{ types.Name }}{{ types.TotalCount1 + types.TotalCount2 }}项</span>
							</li>
						</ul>
					</div>
					<div class="homebox-content-bility" ref="contentList">
						<listHome :rolelist="roleList"></listHome>
					</div>
				</div>
			</div>
		</div>
		<paging
			:total="total"
			:page="page"
			:pageSize.sync="pageSize"
			:pagePrev="pagePrev"
			:pageNext="pageNext"
			@changepage="setPage"
			@changepagesize="setPageSize"
		></paging>
		<!-- <pageSelect
      :total="total"
      :page="page"
      :pageSize="pageSize"
      :pagePrev="pagePrev"
      :pageNext="pageNext"
      @setpage="setPage"
      @setpagesize="setPageSize"
    ></pageSelect>-->
	</div>
</template>

<script>
	// import seclectInput from "@/components/selectVue.vue";
	// import pageSelect from "@/components/pageSelect.vue";
	// import listTitle from '@/components/listTitle.vue'
	import paging from "@/components/paging.vue";
	import listHome from "@/components/listHome.vue";
	import banner from "@/components/bannerOne.vue";
	export default {
		props: {
			areacode: {
				type: [Number, String],
				default: "00",
			},
		},
		data() {
			return {
				typeValue: "请选择类别", //选择的类别名称
				typeId: -1, //选择的类别ID
				unitValue: "请选择部门", //选择的部门名称
				unitId: -1, //选择的部门ID
				keyword: "",
				menuName: "全部",
				typeTotal: 0, //总事项
				total: 0,
				page: 1, //当前页
				pageSize: 30, //显示条数
				pagePrev: "前一页",
				pageNext: "后一页",
				roleList: [],
				typeSelect: [],
				unitSelect: [],
				stepWidth: 0,
				menuWidth: "",
				menuTypeShow: false, //控制 类别和部门选择
				hotList: [],
			};
		},
		components: {
			// seclectInput,
			// pageSelect,
			// listTitle,
			listHome,
			banner,
			paging,
		},
		watch: {
			areacode: {
				immediate: true,
				handler(newValue) {
					this.initRolelist(this.page, this.pageSize, this.unitId, this.affairTypeId, this.keyword);
					this.initHot();
					this.initUnitList();
					this.initTypeSelect();
				},
			},
		},
		methods: {
			changeMenuShow(flag) {
				this.menuTypeShow = flag;
				if (!this.menuTypeShow) {
					this.unitId = -1;
					this.typeId = -1;
					this.menuName = "全部";
					this.initRolelist(this.page, this.pageSize, this.unitId, this.affairTypeId, this.keyword);
				}
				this.initTypeSelect();
			},
			getType(type, num) {
				this.typeValue = type.Name;
				this.typeId = type.Id;
				this.page = 1;
				this.initRolelist(this.page, this.pageSize, this.unitId, type.Id, this.keyword);
				if (num == 1) {
					this.menuName = type.Name;
				}
			},
			getUnit(unit) {
				this.unitValue = unit.Name;
				this.unitId = unit.Id;
				this.initRolelist(this.page, this.pageSize, unit.Id, this.typeId, this.keyword);
				this.menuName = unit.Name;
				this.initTypeSelect();
			},
			search(value) {
				this.keyword = value;
				this.initRolelist(this.page, this.pageSize, this.unitId, this.typeId, this.keyword);
				this.initTypeSelect();
			},
			setPage(page) {
				this.page = page;
				this.initRolelist(this.page, this.pageSize, this.unitId, this.typeId, this.keyword);
			},
			setPageSize(pageSize) {
				this.pageSize = pageSize;
				this.page = 1;
				this.initRolelist(this.page, this.pageSize, this.unitId, this.typeId, this.keyword);
			},
			getRolelistByAffairTypeId(id) {
				this.typeId = id;
				this.initRolelist(this.page, this.pageSize, this.unitId, id, this.keyword);
			},
			initRolelist(page, pageSize, deptId, affairTypeId, keyword) {
				// this.initTypeSelect();
				this.$axios({
					url: "api/getListByWhere",
					method: "get",
					params: {
						areacode: this.areacode,
						page: page,
						pageSize: pageSize,
						deptId: deptId,
						affairTypeId: affairTypeId,
						keyword: keyword,
					},
				})
					.then((res) => {
						this.roleList = res.data.parentList;
						this.total = res.data.totalCount;
						if (keyword) this.$refs.contentList.scrollIntoView({ block: "start", behavior: "smooth" });
					})
					.catch((err) => {
						console.info(err);
					});
			},
			initTypeSelect() {
				this.$axios({
					url: "api/getTypeList",
					method: "get",
					params: {
						areacode: this.areacode,
						deptId: this.unitId,
						keyword: this.keyword,
					},
				})
					.then((res) => {
						this.typeSelect = res.data.typeList;
						// this.typeId = res.data.typeList[0].Id;
						// this.menuName = res.data.typeList[0].Name;
						this.typeTotal = 0;
						for (let type of res.data.typeList) {
							this.typeTotal += Number(type.TotalCount1);
							this.typeTotal += Number(type.TotalCount2);
						}
					})
					.catch((err) => {
						console.info(err);
					});
			},
			initUnitList() {
				this.$axios({
					url: "api/getDeptList",
					method: "get",
					params: {
						areacode: this.areacode,
						deptId: this.unitId,
						keyword: this.keyword,
					},
				})
					.then((res) => {
						this.unitSelect = res.data.deptList;
					})
					.catch((err) => {
						console.info(err);
					});
			},
			initLeft() {
				this.stepWidth = this.$refs.headerMenu.offsetLeft;
				this.menuWidth = 0;
			},
			initHot() {
				this.$axios({
					url: "api/GetHotList",
					method: "get",
					params: {
						areacode: this.areacode,
					},
				})
					.then((res) => {
						this.hotList = res.data.hotList;
					})
					.catch((err) => {
						console.info(err);
					});
			},
		},
		mounted() {
			this.initRolelist(this.page, this.pageSize, this.unitId, this.typeId, this.keyword);
			this.initTypeSelect();
			this.initUnitList();
			this.initLeft();
			this.initHot();
		},
	};
</script>

<style lang="scss" scoped>
	.home {
		width: 100%;
		height: auto;
		position: relative;
		background: linear-gradient(90deg, #ffffff, transparent, transparent);
		// padding: 10px 10px;
		.home-box {
			width: 100%;
			height: auto;
			position: relative;
			.home-box-header {
				width: 100%;
				height: 60px;
				margin-top: -60px;
				display: flex;
				justify-content: flex-start;
				.home-box-header-step {
					height: 60px;
					background-color: #ffffff;
				}
				.home-box-header-menu {
					width: 1200px;
					min-width: 1200px;
					height: 60px;
					left: 0;
					right: 0;
					margin: auto;
					display: flex;
					justify-content: flex-start;
					.header-menu-normal {
						width: 155px;
						height: 60px;
						background-color: #ffffff;
						position: relative;
						z-index: 20;
						line-height: 60px;
						text-align: center;
						cursor: pointer;
						span {
							font-size: 18px;
							font-family: Microsoft YaHei;
							font-weight: bold;
							color: #e22519;
						}
						&.active {
							background-color: #cd0600;
							span {
								color: #ffffff;
							}
						}
					}
					.header-menu-skew {
						width: 165px;
						height: 60px;
						background-color: #ffffff;
						position: relative;
						z-index: 10;
						transform: skew(20deg);
						margin-left: -15px;
						line-height: 60px;
						text-align: center;
						cursor: pointer;
						span {
							display: inline-block;
							font-size: 18px;
							font-family: Microsoft YaHei;
							font-weight: bold;
							color: #e22519;
							transform: skew(-20deg);
						}
						&.active {
							background-color: #cd0600;
							span {
								color: #ffffff;
							}
						}
					}
				}
			}
			.home-box-content {
				width: 1200px;
				height: auto;
				left: 0;
				right: 0;
				margin: auto;
				display: flex;
				.home-box-content-menu {
					width: 314px;
					height: auto;
					min-width: 314px;
					padding: 15px;
					// display: flex;
					// justify-content: flex-start;
					// flex-wrap: wrap;
					ul {
						width: 100%;
						height: auto;
						li {
							width: 134px;
							height: auto;
							list-style-type: none;
							float: left;
							margin: 4px;
							&.active {
								span {
									background-color: #e22519;
									color: #ffffff;
								}
							}
							span {
								display: block;
								width: 134px;
								height: 46px;
								background-color: #ffffff;
								border: 1px solid #e22519;
								border-radius: 2px;
								font-size: 18px;
								font-family: Microsoft YaHei;
								font-weight: 400;
								color: #333333;
								text-align: center;
								line-height: 46px;
								cursor: pointer;
								overflow: hidden;
								text-overflow: ellipsis;
								white-space: nowrap;
								word-break: keep-all;
							}
						}
					}
				}
				.home-box-content-list {
					width: 100%;
					height: auto;
					padding: 20px;
					.home-box-content-header {
						width: 100%;
						height: 50px;
						padding: 15px 40px;
						text-align: left;
						position: relative;
						display: flex;
						justify-content: flex-start;
						align-items: center;
						&::before {
							content: "";
							position: absolute;
							z-index: 25px;
							left: 20px;
							top: 0;
							bottom: 0;
							margin: auto;
							width: 8px;
							height: 20px;
							background-color: #cd0600;
							border-radius: 4px;
						}
						span {
							font-size: 18px;
							font-family: Microsoft YaHei;
							font-weight: 400;
							color: #333333;
							margin-right: 15px;
						}
					}
					.home-box-content-splice {
						width: 100%;
						height: 15px;
						img {
							width: 100%;
							height: 15px;
						}
					}
					.home-box-content-typeList {
						width: 100%;
						height: auto;
						margin-top: 20px;
						display: flex;
						ul {
							width: 100%;
							height: auto;
							li {
								list-style-type: none;
								width: 164px;
								height: 46px;
								float: left;
								text-align: center;
								border: 1px solid #ffcfcc;
								margin: 2px;
								cursor: pointer;
								span {
									line-height: 46px;
									font-size: 16px;
									font-family: Microsoft YaHei;
									font-weight: 400;
									color: #666666;
								}
								&.active {
									background-color: #cd0600;
									span {
										color: #ffffff;
									}
								}
							}
						}
					}
					.homebox-content-bility {
						width: 100%;
						height: auto;
						margin-top: 20px;
					}
				}
			}
			// margin: 20px 0;
			// &.home_menu_border_bottom {
			//   padding-bottom: 20px;
			//   border-bottom: 1px dashed #718093;
			// }
			// .qzTotal {
			//   height: 40px;
			//   line-height: 40px;
			//   font-size: 20px;
			//   font-weight: bold;
			//   letter-spacing: 2px;
			// }
			// .qz-input {
			//   width: 280px;
			//   height: 40px;
			//   align-items: center;
			//   // border: 1px solid #c0392b;
			//   // background-color: rgba(255, 255, 255, 0.4);
			//   .qz-input-box {
			//     width: 200px;
			//     height: 30px;
			//     input {
			//       width: 100%;
			//       height: 100%;
			//       line-height: 30px;
			//       font-size: 16px;
			//       background-color: transparent;
			//       border: 1px solid rgba(33, 33, 33, 0.3);
			//       outline: none;
			//       color: #212121;
			//       font-weight: bold;
			//       padding: 0 5px;
			//       &::-webkit-input-placeholder {
			//         color: #2c3e50;
			//         font-size: 16px;
			//       }

			//       &:-moz-placeholder {
			//         color: #2c3e50;
			//         font-size: 16px;
			//       }

			//       &:-ms-input-placeholde {
			//         color: #2c3e50;
			//         font-size: 16px;
			//       }
			//     }
			//   }
			//   .qz-input-btn {
			//     width: 80px;
			//     height: 30px;
			//     display: flex;
			//     justify-content: center;
			//     align-items: center;
			//     img {
			//       width: 30px;
			//       height: 30px;
			//     }
			//     p {
			//       width: 100%;
			//       height: 100%;
			//       line-height: 30px;
			//       background-color: #feca57;
			//       color: #ffffff;
			//       cursor: pointer;
			//     }
			//   }
			// }
		}
		.select-flex {
			display: flex;
			justify-content: flex-start;
		}
		.flex-between {
			display: flex;
			justify-content: space-between;
		}
		.type-list-flex {
			display: flex;
			flex-wrap: wrap;
			justify-content: space-evenly;
			align-items: center;
			.type-list {
				width: 15%;
				height: 30px;
				margin: 5px 50px;
				// border: 1px solid #212121;
				color: #4e4e4e;
				padding: 0 20px;
				display: flex;
				justify-content: space-between;
				align-items: center;
				// background: linear-gradient(145deg, #f6e58d, #ff7979);
				background: linear-gradient(145deg, #1488cc, #26d0ce);
				transition: all 0.5s;
				cursor: pointer;
				color: #ffffff;
				&:hover {
					border-radius: 15px;
					background: linear-gradient(145deg, #26d0ce, #1488cc);
				}
				&.typeActive {
					border-radius: 15px;
					background: linear-gradient(145deg, #26d0ce, #1488cc);
				}
			}
		}
	}

	.borderBot {
		border-bottom: 1px dashed #718093;
	}
</style>
